<script setup>
  import { computed, defineEmits, defineProps } from 'vue';

  const props = defineProps({
    visible: Boolean,
    value: String,
    imgSrc: String,
    beforeClose: Function,
  });
  const emit = defineEmits(['update:visible', 'input', 'changeImg']);

  const visible = computed({
    get() {
      return props.visible;
    },
    set(val) {
      emit('update:visible', val);
    },
  });
  const imgCode = computed({
    get() {
      return props.value;
    },
    set(val) {
      emit('input', val);
    },
  });
</script>

<template>
  <van-dialog
    v-model="visible"
    :title="$t('dialog.imgCode')"
    show-cancel-button
    :before-close="props.beforeClose"
    :confirm-button-text="$t('dialog.confirmButton')"
    :cancel-button-text="$t('dialog.cancelButton')"
  >
    <div class="flex">
      <el-input
        v-model="imgCode"
        maxlength="4"
        class="custom-input mr-1"
        :placeholder="$t('dialog.imgCode')"
      >
      </el-input>
      <van-image
        class="flex-shrink-0 rounded custom-img"
        :src="props.imgSrc"
        @click="emit('changeImg')"
        alt=""
      ></van-image>
    </div>
  </van-dialog>
</template>

<style scoped lang="less">
  .custom-input {
    :deep(.el-input__inner) {
      background-color: #f5f6f8;
      border: none !important;
      height: 36px;
    }

    :deep(.el-input__suffix) {
      right: 0;
    }
  }

  .custom-img {
    width: 88px;
  }

  :deep(.van-dialog__content) {
    padding-top: 16px;

    img,
    .van-image__loading {
      border-radius: 4px;
    }
  }
</style>
